import { render, staticRenderFns } from "./MonitorsDetails.vue?vue&type=template&id=3282dcfe&"
import script from "./MonitorsDetails.vue?vue&type=script&lang=js&"
export * from "./MonitorsDetails.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports